<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Inserisci rilievo">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-outline-primary mt-3 mr-2" ngbDropdownToggle id="rilievoDettaglioAzioni">
                        Azioni
                        <app-toolkit-bl-icon icon="arrow-down-triangle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="rilievoDettaglioAzioni">
                        <button ngbDropdownItem [routerLink]="['..']">
                            <app-toolkit-bl-icon icon="arrow-left" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                            Torna indietro
                        </button>
                    </div>
                </div>
            </app-toolkit-page-title>
            <div class="steppers">
                <app-toolkit-rilievo-tab-anagrafica-rilievo [canEdit]="true" [formGroup]="criteriaForm"></app-toolkit-rilievo-tab-anagrafica-rilievo>
                <nav class="text-right">
                    <button type="button" class="btn btn-primary steppers-btn-confirm" (click)="inserisciRilievo()">{{'Conferma'}}</button>
                </nav>
            </div>
        </div>
    </div>
</div>